export default "__VITE_ASSET__Z8sdfJQS__"